// import { FuseNavigation } from 'src/@fuse/types';

export const navigation: any[] = [
  {
    id: 'applications',
    title: 'Applications',
    translate: 'NAV.APPLICATIONS',
    type: 'group',
    children: [
      {
        id: 'matters',
        title: 'Matters',
        translate: 'NAV.MATTERS.TITLE',
        type: 'item',
        icon: 'Frame 36.svg',
        url: 'matters',
      },
      {
        id: 'contact',
        title: 'Contact',
        translate: 'NAV.CONTACT.TITLE',
        type: 'item',
        icon: 'icon_contact_d.ico',
        url: 'contact',
      },
    ],
  },
];
